import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionListData, SubscriptionListFilter, SubscriptionSortList } from '../../features/companies/models/companyProfile';
import { CompanyProfileService } from '../../features/companies/services/companyProfile.service';
import { CompaniesService } from '../../features/companies/services/companies.service';

@Component({
  selector: 'app-company-subscriptions-details',
  templateUrl: './company-subscriptions-details.component.html'
})
export class CompanySubscriptionsDetailsComponent implements OnInit {

  dataLoading = false;
  showSearch = false;
  showFilter = false;

  pageIndex = 0;
  pageSize = 10;
  pageCount = 0;
  recordsData!: SubscriptionListData | null;

  @Input() companyId!: any;
  @Input() isActive!: any;
  @Input() index!: number;

  filterModel: SubscriptionListFilter = new SubscriptionListFilter();

  sortItems = [
    { name: 'companyProfile.subscription end date', sort: '', sortBy: SubscriptionSortList.end_date, value: SubscriptionSortList.end_date },
    { name: 'general.Newest', sort: SubscriptionSortList.DESC, sortBy: '', value: SubscriptionSortList.DESC },
    { name: 'general.Oldest', sort: SubscriptionSortList.ASC, sortBy: '', value: SubscriptionSortList.ASC },
  ];
  currentSortSelection!: any;

  packages!: any | null;
  packagesLoading = false;


  // Subscriptions (sort by subscription end date “default sort”, newest, oldest) (search by: package name) (filter by: package)
  // name,created_at,end_date,start_date

  constructor(
    private translate: TranslateService,
    private service: CompanyProfileService,
    private companyService: CompaniesService) { }

  ngOnInit(): void {
    this.currentSortSelection = this.sortItems[0].value;
  }

  ngOnChanges(changes: any): void {
    if (changes.isActive?.currentValue && changes.isActive?.currentValue == this.index) {
      this.getAll(null);
      this.getAllPackages();
    }
  }

  OnSelectSortType() {
    if (this.currentSortSelection == SubscriptionSortList.DESC || this.currentSortSelection == SubscriptionSortList.ASC) {
      this.filterModel.sort = this.currentSortSelection;
      this.filterModel.sortBy = '';
    }
    else {
      this.filterModel.sort = ''
      this.filterModel.sortBy = this.currentSortSelection;
    }
  }

  makeSearch() {
    if (!this.showSearch) {
      this.showSearch = true; // Show input
    } else {
      if (this.filterModel.search) {
        this.getAll(null);
      }
    }
  }

  resetSearch() {
    this.filterModel.search = '';
    this.getAll(null);
  }

  getAllPackages() {
    this.packagesLoading = true;
    this.companyService.GetPackages(null).subscribe((data) => {
      this.packagesLoading = false;
      this.packages = data.data.list;
    })
  }

  getAll(event: any) {
    this.dataLoading = true;
    if (!event) {
      this.pageIndex = this.pageIndex;
      this.pageSize = this.pageSize;
    }
    if (event && event.pageSize) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    this.filterModel.page = this.pageIndex + 1;
    this.filterModel.perPage = this.pageSize;
    this.filterModel.company_id = this.companyId;
    if (this.filterModel.package_id) {
      this.filterModel.package_id = this.filterModel.package_id
    } else {
      this.filterModel.package_id = ''
    }
    this.service.getSubscriptions(this.filterModel).subscribe((res: SubscriptionListData) => {
      this.dataLoading = false;
      if (res) {
        this.recordsData = res;
        this.pageCount = Math.ceil(this.recordsData.data.total / this.filterModel.perPage);
      }
    },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });
  }
}
